<script>
  import {mapActions, mapGetters} from 'vuex'

  let buildInitialSelections = function (consentsConfig) {
    let selections = {};
    (consentsConfig || []).forEach(c => {
      // required consents default to true (must be accepted to proceed);
      // optional consents default to false (unchecked)
      selections[c.type] = !!c.required;
    });
    return selections;
  };

  export default {
    name: 'PrivacyAgreement',

    props: ['isCompleted', 'isReady'],

    computed: {
      ...mapGetters(['getLabel', 'getSelectedHospital', 'getPrivacyPolicyText', 'getConsentsConfig']),

      canProceed: function () {
        return (this.getConsentsConfig || []).every(c => !c.required || this.selections[c.type] === true);
      },
    },

    watch: {
      getConsentsConfig: {
        immediate: true,
        handler: function (newConfig) {
          this.selections = buildInitialSelections(newConfig);
        },
      },
    },

    mounted: function () {
      let ctx = this;
      this.eventHub.$on("resetAll", event => {
        ctx.reset(true);
      });
    },

    methods: {
      ...mapActions(['completeStep', 'setPrivacyAgreement', 'resetStepsTo']),

      buildConsentsPayload: function (accepted) {
        return (this.getConsentsConfig || []).map(c => ({
          type: c.type,
          value: accepted ? this.selections[c.type] === true : false,
        }));
      },

      proceed: function () {
        if (!this.canProceed) {
          return;
        }
        this.setPrivacyAgreement({
          consents: this.buildConsentsPayload(true),
        });
        this.$analytics.pushEvent("privacy:step-completed");
        this.completeStep(1);
      },

      reset: function (force) {

        if (force) {
          this.setPrivacyAgreement({
            consents: this.buildConsentsPayload(false),
          });

          this.selections = buildInitialSelections(this.getConsentsConfig);
        } else {
          this.resetStepsTo(1);
        }
      }
    },

    data: function () {
      return {
        selections: {},
      }
    },
  }
</script>

<template>
  <div class="privacy-agreement wrap-step" :class="{uncompleted : !isReady, checked : isCompleted}">
    <h4>
      <Msg id="ospedali.form.privacyagreement.title"/>
    </h4>
    <div v-if="!isCompleted && isReady">
      <div class="policy-text" v-html="getPrivacyPolicyText"></div>

      <div class="wrap-check" v-for="consent in getConsentsConfig" :key="consent.type">
        <input type="checkbox" :id="consent.type" v-model="selections[consent.type]" :required="consent.required">
        <label :for="consent.type">
          <span v-if="consent.text" v-html="consent.text"></span>
          <span v-else>{{ consent.label }}</span>
          <span v-if="consent.required" class="required-marker">*</span>
        </label>
      </div>
      <div class="wrap-main-cta">
        <button @click="proceed()" class="button-primary" :disabled="!canProceed">{{getLabel('ospedali.form.button.proceeed')}}</button>
      </div>

    </div>
    <div v-else-if="isCompleted">
      <span>{{getLabel('ospedali.form.privacy.accepted')}}</span>
      <button @click="reset(false)" class="button-text">{{getLabel("ospedali.form.button.modify")}}</button>
    </div>

  </div>
</template>